module.exports = __webpack_public_path__ + "img/userInformatica1.8309f81c.png";